import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { labelActions } from '@common-reducers/labels-reducer';
import { Loader2, AlertTriangle } from 'lucide-react';
import LabelForm from '../label-input-with-emoji-picker';
import { deleteLabelThunk } from '@common-reducers/labels-reducer/labels-thunks/crud';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog"
import { useTranslation } from 'react-i18next';
import { namespace } from "@common-config/constants";


export default function DeleteLabelModalModal() {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch()
    const isLabelDeleting = useAppSelector((state) => state.LabelReducer.isLabelDeleting)
    const labelNetWorkStatus = useAppSelector((state) => state.LabelReducer.labelNetWorkStatus)

    const handleOpenChange = (open: boolean) => {
        dispatch(labelActions.setLabel({}))
        dispatch(labelActions.toggleDeleteLabel(open))
    }

    return (
        <Dialog open={isLabelDeleting} onOpenChange={handleOpenChange}>
            <DialogContent className="sm:max-w-md p-0 gap-0 overflow-hidden bg-white">
                <DialogHeader className="px-6 py-4 border-b border-zinc-100">
                    <div className="flex items-center gap-2">
                        <AlertTriangle size={20} className="text-red-600" />
                        <DialogTitle className="text-lg font-semibold text-zinc-900">{t('labels.deleteLabel')}</DialogTitle>
                    </div>
                </DialogHeader>

                <div className="px-6 py-4">
                    <LabelForm disabled={true} />
                    <p className="mt-3 text-sm text-gray-600">
                        {t('labels.deleteLabelWarning')}
                    </p>
                </div>

                <div className="flex gap-3 px-6 pb-6">
                    <Button
                        variant="secondary"
                        onClick={() => handleOpenChange(false)}
                        className="flex-1 h-10 rounded-md font-medium text-gray-700 bg-gray-100 hover:bg-gray-200"
                    >
                        {t('common.cancel')}
                    </Button>
                    <Button
                        onClick={() => dispatch(deleteLabelThunk())}
                        disabled={labelNetWorkStatus === 'delete-label'}
                        className="flex-1 gap-2 h-10 rounded-md font-medium bg-red-600 hover:bg-red-700 text-white disabled:bg-red-400"
                    >
                        {labelNetWorkStatus === 'delete-label' ? (
                            <>
                                <Loader2 size={16} className="animate-spin" />
                                {t('labels.deleting')}
                            </>
                        ) : (
                            t('common.delete')
                        )}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
